/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef } from "react";
import { QueryClientProvider } from '@tanstack/react-query';
import { AtomsThemeProvider, GlobalStyles } from '@selfbook/atoms-v2';
import reactQueryClient from './store/reactQueryClient';
import useWidgetStore from './store/useWidgetStore';
import { Widget, WidgetMobile } from './components';

export default function App() {
  const roomsMounted = useRef(false);
  const hotelData = useWidgetStore((state) => state.hotelData);
  const theme = useWidgetStore((state) => state.theme);

  useEffect(() => {
    if (hotelData && !roomsMounted.current) {
      useWidgetStore.getState().roomAdd();
    }
  }, [!!hotelData]);

  return (
    <QueryClientProvider client={reactQueryClient}>
      <AtomsThemeProvider theme={theme}>
        <GlobalStyles />
        <Widget />
        <WidgetMobile />
      </AtomsThemeProvider>
    </QueryClientProvider>
  );
}
